/**
 * Canonicalize a tenant id: trim surrounding whitespace and lower-case.
 * Tenant ids are case-insensitive; this is the single normalization point so
 * the store, localStorage, and outbound API calls all agree on shape.
 * Non-string input (null/undefined) is returned unchanged.
 *
 * @param {string} tenantId
 * @returns {string}
 */
export const normalizeTenantId = (tenantId) =>
	typeof tenantId === "string" ? tenantId.trim().toLowerCase() : tenantId;
